import * as React from "react";
import SettingsContainer from "./settings.container";
import DetailSelectedContainer from "./detailSelected.container";
import ContactContainer from "./contact.container";
import CotizacionContainer from "./cotizacion.container";
import ShowOverlayContainer from "./showOverlay.container";

declare const window: any;

export default function TopBarContainer({
  subMenuSelected,
  menuSelected,
  setMenuSelected,
  setSubMenuSelected,
  colors,
  theme,
  active,
  setIsTheme,
  setFrame,
  setShow,
  show,
  setShowTextHotspots,
  showTextHotspots,
  isPortrait,
  isContactBtn,
  setIsContactModal,
  isLoading,
  setIsCotizacion,
  cotizacion,
  isCotizacion,
  properties,
  isSelectedAptoView,
  setIsSelectedAptoView,
  hotspotsSelected,
  setHotspotsSelected,
  version,
  lite,
  languages,
  selectedLanguage,
  setSelectedLanguage,
  multiLanguage,
  setMultiLanguage,
}: any) {
  const [animationIntro, setAnimationIntro] = React.useState(false);
  const [detailedTitle, setDetailedTitle] = React.useState("");

  React.useEffect(() => {
    setAnimationIntro(false);
    setTimeout(() => {
      setAnimationIntro(true);
    }, 500);
  }, [active]);

  React.useEffect(() => {
    if (!isSelectedAptoView) {
      setDetailedTitle("");
      return;
    }

    for (const value of isSelectedAptoView.values) {
      if (value.hierarchicalLevel.toLocaleLowerCase() === "jerarquico #1") {
        setDetailedTitle(value.value + " - " + isSelectedAptoView.property);
        break;
      }
    }
  }, [isSelectedAptoView]);

  return (
    <div
      className={`top-bar-container ${
        animationIntro ? active + " animation" : active
      }`}
    >
      {/* {menuSelected === "Inmuebles" && subMenuSelected !== "" && detailedTitle === "" ? (
        <DetailSelectedContainer
          detail={subMenuSelected}
          setMenuSelected={setMenuSelected}
          setSubMenuSelected={setSubMenuSelected}
          setIsSelectedAptoView={setIsSelectedAptoView}
          theme={theme}
          colors={colors}
          setIsTheme={setIsTheme}
          setFrame={setFrame}
          properties={properties}
          hotspotsSelected={hotspotsSelected}
          setHotspotsSelected={setHotspotsSelected}
          isPropertyView={false}
        />
      ) : null}
      {menuSelected === "Inmuebles" && detailedTitle !== "" ? (
        <DetailSelectedContainer
          detail={detailedTitle}
          setMenuSelected={setMenuSelected}
          setSubMenuSelected={setSubMenuSelected}
          setIsSelectedAptoView={setIsSelectedAptoView}
          theme={theme}
          colors={colors}
          setIsTheme={setIsTheme}
          setFrame={setFrame}
          properties={properties}
          hotspotsSelected={hotspotsSelected}
          setHotspotsSelected={setHotspotsSelected}
          isPropertyView={true}
        />
      ) : null} */}
      {cotizacion ? (
        <CotizacionContainer
          colors={colors}
          setIsCotizacion={setIsCotizacion}
          setMenuSelected={setMenuSelected}
          menuSelected={menuSelected}
          setSubMenuSelected={setSubMenuSelected}
          isCotizacion={isCotizacion}
          theme={theme}
        />
      ) : null}
      {!lite && (
        <ShowOverlayContainer
          colors={colors}
          setShowTextHotspots={setShowTextHotspots}
          showTextHotspots={showTextHotspots}
        />
      )}
      {isContactBtn && !lite ? (
        <ContactContainer
          colors={colors}
          setIsContactModal={setIsContactModal}
          isContactBtn={isContactBtn}
          setIsCotizacion={setIsCotizacion}
        />
      ) : null}
      {isContactBtn && !lite ? (
        <ContactContainer
          colors={colors}
          setIsContactModal={setIsContactModal}
          isContactBtn={isContactBtn}
          setIsCotizacion={setIsCotizacion}
        />
      ) : null}
      <SettingsContainer
        theme={theme}
        colors={colors}
        setIsTheme={setIsTheme}
        menuSelected={menuSelected}
        setShow={setShow}
        show={show}
        setShowTextHotspots={setShowTextHotspots}
        showTextHotspots={showTextHotspots}
        animationIntro={animationIntro}
        isPortrait={isPortrait}
        setIsCotizacion={setIsCotizacion}
        version={version}
        languages={languages}
        selectedLanguage={selectedLanguage}
        setSelectedLanguage={setSelectedLanguage}
        multiLanguage={multiLanguage}
        setMultiLanguage={setMultiLanguage}
      />
    </div>
  );
}
